import { captureException } from '@sentry/browser';
import axios from 'axios';
import { NetworkSection } from '../core/domain/Network';
import { ExternalNetworkPort } from '../core/networkState/ExternalNetworkPort';

export class ExternalNetworkProvider implements ExternalNetworkPort {
    constructor(private readonly baseEndpoint: string) {}

    async loadNetworkSections(): Promise<NetworkSection[]> {
        try {
            const response = await axios.request({
                method: 'GET',
                url: `${this.baseEndpoint}/network-state`,
                withCredentials: true,
            });

            return response.data;
        } catch (err) {
            console.error(err);
            captureException(err);
            throw err;
        }
    }
}
